import React from "react";
import BarVeritical from "../Charts/BarVeritical";
import BarVeriticalStack from "../Charts/BarVeriticalStack";

const Finance = ({ t, data }) => {
  const { memberDonations, membershipFees, stateFunding, partyIncome } =
    data.financialInfo;
  return (
    <div className="px-0 bg-white pt-10 pb-10">
      <span className="text-22 font-medium md:text-32">{t("whoFinances")}</span>
      <div className="h-[1px] bg-black bg-opacity-40 mb-7"></div>

      <div className="flex flex-col md:grid md:grid-cols-2 md:gap-10">
        <div className="flex flex-col chart-box">
          <div className="flex flex-col">
            <span className="text-lg font-medium leading-6">
              {t("memberDonations")}
            </span>
            <span className="leading-[17px]">{t("inEuros")}</span>
          </div>
          <div className="h-[250px] lg:h-[250px] pt-3">
            <BarVeritical data={memberDonations.slice(-7)} className="h-full" />
          </div>
          <span className="text-xs text-black/70 mt-5">{t("sourceOne")}</span>
        </div>

        <div className="flex flex-col md:mt-0 mt-10 chart-box">
          <div className="flex flex-col">
            <span className="text-lg font-medium leading-6">
              {t("membershipFees")}
            </span>
            <span className="leading-[17px]">{t("inEuros")}</span>
          </div>
          <div className="h-[250px] lg:h-[250px] pt-3">
            <BarVeritical data={membershipFees.slice(-7)} className="h-full" />
          </div>
          <span className="text-xs text-black/70 mt-5">{t("sourceOne")}</span>
        </div>

        <div className="flex flex-col md:mt-0 mt-10 chart-box">
          <div className="flex flex-col">
            <span className="text-lg font-medium leading-6">
              {t("stateFunding")}
            </span>
            <span className="leading-[17px]">{t("inEuros")}</span>
          </div>
          <div className="h-[250px] lg:h-[250px] pt-3">
            <BarVeritical data={stateFunding.slice(-7)} className="h-full" />
          </div>
          <span className="text-xs text-black/70 mt-5">{t("sourceOne")}</span>
        </div>

        <div className="flex flex-col md:mt-0 mt-10 chart-box">
          <div className="flex flex-col">
            <span className="text-lg font-medium leading-6">
              {t("partyIncome")}
            </span>
            <span className="leading-[17px]">{t("inEuros")}</span>
          </div>
          <div className="h-[250px] lg:h-[250px] pt-3">
            <BarVeriticalStack
              data={partyIncome.slice(-7)}
              className="h-full"
              t={t}
            />
          </div>
          <div className="flex flex-row justify-start">
            <div className="flex flex-col mt-3 mr-10">
              <div className="flex items-center mb-1">
                <div className="w-4 h-3 bg-[#D3D3D3] mr-2" />
                <span className="text-xs">{t("membershipFees")}</span>
              </div>
              <div className="flex items-center mb-1">
                <div className="w-4 h-3 bg-[#E88B00] mr-2" />
                <span className="text-xs">
                  {t("contributionRepresentatives")}
                </span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-3 bg-[#71C0DB] mr-2" />
                <span className="text-xs">{t("publicFunding")}</span>
              </div>
            </div>

            <div className="flex flex-col mt-3">
              <div className="flex items-center mb-1">
                <div className="w-4 h-3 bg-[#561D25] mr-2" />
                <span className="text-xs">{t("donations")}</span>
              </div>
              <div className="flex items-center mb-1">
                <div className="w-4 h-3 bg-[#84569A] mr-2" />
                <span className="text-xs">{t("others")}</span>
              </div>
            </div>
          </div>
          <span className="text-xs text-black/70 mt-5">{t("sourceOne")}</span>
        </div>
      </div>
    </div>
  );
};

export default Finance;
